// extracted by mini-css-extract-plugin
module.exports = {"galery":"Gallery_galery__2I9aa","items":"Gallery_items__3cViS","card":"Gallery_card__3xIWL"};